import { subscribeToAuth, signOut } from "../services/auth.js";
import { db, auth } from "../services/firebase.js";
import { collection, getDocs, doc, updateDoc, setDoc, query, where, getDoc, addDoc } from "firebase/firestore";

window.currentStudentProfile = null;

function hideSplash() {
  const splash = document.getElementById("splash-screen");
  if (splash) {
    splash.classList.add("hidden");
    setTimeout(() => splash.remove(), 500);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  initStudentPanel();
});

function initStudentPanel() {
  subscribeToAuth(async (user) => {
    if (!user) {
      hideSplash();
      window.location.href = "./index.html";
      return;
    }

    const profile = user.profile || {
      name: user.displayName || "Usuário",
      email: user.email,
      role: "colaborador"
    };

    if (profile.role !== "colaborador") {
      hideSplash();
      window.location.href = `./painel-${profile.role}.html`;
      return;
    }

    window.currentStudentProfile = profile;
    console.log(`🎓 Inicializando Painel do Aluno: ${profile.name}`);

    updateProfileUI(profile);
    setupNavigation();
    setupSiscoafNav();
    setupLogout();
    setupMobileMenu();
    setupSearch();

    try {
      await handleUserStreak(user.uid, profile);
    } catch (err) {
      console.error("Erro ao gerenciar Streak:", err);
    }

    await refreshStudentDashboard(user.uid);
    hideSplash();
  });
}

function updateProfileUI(profile) {
  const welcomeTitle = document.querySelector(".page-title");
  if (welcomeTitle) {
    welcomeTitle.innerText = `Olá, ${profile.name}`;
  }

  const dateEl = document.getElementById("current-date");
  if (dateEl) {
    const now = new Date();
    const options = { day: "2-digit", month: "long", year: "numeric" };
    dateEl.innerText = now.toLocaleDateString("pt-BR", options);
  }

  const settingsNameInput = document.getElementById("settings-name-input");
  const settingsEmailInput = document.getElementById("settings-email-input");

  if (settingsNameInput) settingsNameInput.value = profile.name;
  if (settingsEmailInput) settingsEmailInput.value = profile.email;
}

function setupNavigation() {
  const navLinks = document.querySelectorAll(".nav-link, .bottom-nav-link, .drawer-link");
  const tabs = document.querySelectorAll(".tab-content");
  const tabMap = {
    "nav-dashboard": "tab-dashboard-content",
    "bottom-nav-dashboard": "tab-dashboard-content",
    "drawer-progress": "tab-dashboard-content",
    "nav-courses": "tab-courses-content",
    "bottom-nav-courses": "tab-courses-content",
    "nav-available-courses": "tab-available-courses-content",
    "drawer-available-courses": "tab-available-courses-content",
    "nav-certificates": "tab-certificates-content",
    "bottom-nav-certificates": "tab-certificates-content",
    "nav-progress": "tab-progress-content",
    "drawer-progress": "tab-progress-content",
    "nav-favorites": "tab-favorites-content",
    "drawer-favorites": "tab-favorites-content",
    "nav-history": "tab-history-content",
    "drawer-history": "tab-history-content",
    "nav-siscoaf": "tab-siscoaf-content",
    "nav-siscoaf-analise": "tab-siscoaf-content",
    "nav-siscoaf-dashboard": "tab-siscoaf-content",
    "nav-siscoaf-historico": "tab-siscoaf-content",
    "nav-siscoaf-config": "tab-siscoaf-content",
    "nav-siscoaf-usuarios": "tab-siscoaf-content",
    "drawer-siscoaf": "tab-siscoaf-content",
    "nav-settings": "tab-settings-content",
    "bottom-nav-settings": "tab-settings-content",
    "drawer-settings": "tab-settings-content"
  };

  navLinks.forEach(link => {
    link.addEventListener("click", (e) => {
      const linkId = link.getAttribute("id");
      const tabId = tabMap[linkId];

      if (tabId) {
        e.preventDefault();
        tabs.forEach(t => t.classList.remove("active"));
        const targetTab = document.getElementById(tabId);
        if (targetTab) targetTab.classList.add("active");

        navLinks.forEach(l => l.classList.remove("active"));
        link.classList.add("active");

        if (tabId === 'tab-favorites-content' && typeof renderFavoritesGrid === 'function') {
          renderFavoritesGrid();
        }
      }
    });
  });
}

// ===== SISCOAF NAVIGATION =====
var siscoafPageMap = {
  'nav-siscoaf-analise': '/siscoaf/index.html?embedded=1',
  'nav-siscoaf-dashboard': '/siscoaf/admin.html?embedded=1',
  'nav-siscoaf-historico': '/siscoaf/historico.html?embedded=1',
  'nav-siscoaf-config': '/siscoaf/configuracoes.html?embedded=1',
  'nav-siscoaf-usuarios': '/siscoaf/usuarios.html?embedded=1',
};

function setupSiscoafNav() {
  var iframe = document.getElementById('siscoaf-iframe');
  if (!iframe) return;
  Object.keys(siscoafPageMap).forEach(function(linkId) {
    var link = document.getElementById(linkId);
    if (!link) return;
    link.addEventListener('click', function(e) {
      e.preventDefault();
      iframe.src = siscoafPageMap[linkId];
      localStorage.setItem('siscoaf_last_page', iframe.src);
    });
  });
  var lastPage = localStorage.getItem('siscoaf_last_page');
  if (lastPage && iframe) iframe.src = lastPage;
}

function sendSiscoafAuth() {
  var iframe = document.getElementById('siscoaf-iframe');
  if (!iframe || !iframe.contentWindow) return;
  if (!auth.currentUser) { setTimeout(sendSiscoafAuth, 500); return; }
  var user = auth.currentUser;
  var userRef = doc(db, 'users', user.uid);
  getDoc(userRef).then(function(snap) {
    if (!snap.exists()) return;
    var data = snap.data();
    var role = data.role || 'colaborador';
    var serventia = data.serventia || 'Ambos';
    var siscoafRole = (role === 'admin' || role === 'instrutor') ? 'admin' : 'restrito';
    iframe.contentWindow.postMessage({
      type: 'siscoaf-auth',
      uid: user.uid,
      nome: user.displayName || data.name || 'Usuário',
      email: user.email,
      role: siscoafRole,
      serventia: serventia,
      orgId: data.orgId || ''
    }, '*');
  });
}

window.addEventListener('message', function(e) {
  if (e.data && e.data.type === 'siscoaf-ready') sendSiscoafAuth();
});

function resizeSiscoafIframe() {
  var iframe = document.getElementById('siscoaf-iframe');
  if (!iframe) return;
  try {
    var docEl = iframe.contentWindow.document.documentElement;
    var height = Math.max(docEl.scrollHeight, docEl.offsetHeight, docEl.clientHeight);
    iframe.style.height = Math.max(height, window.innerHeight - 120) + 'px';
  } catch(e) {}
}

document.addEventListener('DOMContentLoaded', function() {
  var iframe = document.getElementById('siscoaf-iframe');
  if (iframe) {
    iframe.addEventListener('load', function() {
      setTimeout(resizeSiscoafIframe, 500);
      setInterval(resizeSiscoafIframe, 2000);
    });
  }
});

function setupLogout() {
  const logoutLinks = document.querySelectorAll(".logout-link, [id*='logout']");
  logoutLinks.forEach(btn => {
    btn.addEventListener("click", async (e) => {
      e.preventDefault();
      const confirmed = await window.showConfirm("Deseja realmente sair da sua conta?");
      if (confirmed) {
        sessionStorage.removeItem('siscoaf_user');
        await signOut();
        window.location.href = "./index.html";
      }
    });
  });
}

function setupMobileMenu() {
  const toggleBtn = document.getElementById("mobile-menu-toggle");
  const drawer = document.getElementById("mobile-drawer");
  const overlay = document.getElementById("mobile-drawer-overlay");
  const closeBtn = document.getElementById("btn-close-drawer");

  if (toggleBtn && drawer) {
    toggleBtn.addEventListener("click", () => {
      drawer.classList.add("open");
      if (overlay) overlay.classList.add("open");
    });
  }

  if (closeBtn && drawer) {
    closeBtn.addEventListener("click", () => {
      drawer.classList.remove("open");
      if (overlay) overlay.classList.remove("open");
    });
  }

  if (overlay) {
    overlay.addEventListener("click", () => {
      drawer.classList.remove("open");
      overlay.classList.remove("open");
    });
  }
}

function setupSearch() {
  const searchModal = document.getElementById("search-modal");
  const searchInput = document.getElementById("search-input");
  const resultsContainer = document.getElementById("search-results-list");

  if (!searchModal || !searchInput) return;

  searchInput.addEventListener("input", async (e) => {
    const query = e.target.value.trim().toLowerCase();
    if (query.length < 2) {
      resultsContainer.innerHTML = "";
      return;
    }

    try {
      const coursesSnap = await getDocs(collection(db, "courses"));
      const results = [];
      coursesSnap.forEach(d => {
        const data = d.data();
        if (data.title && data.title.toLowerCase().includes(query)) {
          results.push({ id: d.id, ...data });
        }
      });

      if (results.length === 0) {
        resultsContainer.innerHTML = '<div style="padding: 16px; text-align: center; color: var(--text-secondary);">Nenhum curso encontrado.</div>';
        return;
      }

      resultsContainer.innerHTML = results.slice(0, 5).map(c => `
        <div class="search-result-item" data-course-id="${c.id}" style="padding: 12px; cursor: pointer; border-bottom: 1px solid rgba(11,27,94,0.06); transition: background 0.2s;">
          <div style="font-weight: 600; color: var(--blue-deep);">${c.title}</div>
          <div style="font-size: 0.85rem; color: var(--text-secondary);">${c.description ? c.description.substring(0, 60) + "..." : ""}</div>
        </div>
      `).join("");

      resultsContainer.querySelectorAll(".search-result-item").forEach(item => {
        item.addEventListener("click", () => {
          const courseId = item.dataset.courseId;
          window.location.href = `./course.html?courseId=${courseId}`;
        });
      });

    } catch (err) {
      console.error("Erro na busca:", err);
    }
  });

  document.addEventListener("keydown", (e) => {
    if ((e.ctrlKey || e.metaKey) && e.key === "k") {
      e.preventDefault();
      searchModal.classList.add("open");
      searchInput.focus();
    }
    if (e.key === "Escape" && searchModal.classList.contains("open")) {
      searchModal.classList.remove("open");
    }
  });

  searchModal.addEventListener("click", (e) => {
    if (e.target === searchModal) {
      searchModal.classList.remove("open");
    }
  });
}

async function handleUserStreak(uid, profile) {
  const today = new Date().toLocaleDateString("pt-BR").split("/").reverse().join("-");
  const lastAccess = profile.lastAccess || "";
  const currentStreak = profile.streak || 0;

  if (lastAccess === today) {
    updateStreakUI(currentStreak);
    return;
  }

  const yesterdayDate = new Date();
  yesterdayDate.setDate(yesterdayDate.getDate() - 1);
  const yesterday = yesterdayDate.toLocaleDateString("pt-BR").split("/").reverse().join("-");

  let newStreak = 1;
  if (lastAccess === yesterday) {
    newStreak = currentStreak + 1;
  }

  const userRef = doc(db, "users", uid);
  await updateDoc(userRef, {
    lastAccess: today,
    streak: newStreak
  });

  profile.streak = newStreak;
  profile.lastAccess = today;
  updateStreakUI(newStreak);
}

function updateStreakUI(streak) {
  const streakTitle = document.getElementById("student-streak-title");
  if (streakTitle) {
    streakTitle.innerText = `Streak Atual: ${streak} dias seguidos`;
  }
}

async function refreshStudentDashboard(uid) {
  try {
    showDashboardSkeletons();

    const profileDoc = await getDoc(doc(db, "users", uid));
    let profile = window.currentStudentProfile;
    if (profileDoc.exists()) {
      profile = profileDoc.data();
      window.currentStudentProfile = profile;
    }

    const pointsVal = document.getElementById("student-points-value");
    const levelVal = document.getElementById("student-level-value");
    const badgesVal = document.getElementById("student-badges-value");
    const hoursVal = document.getElementById("student-widget-hours");
    const hoursSub = document.getElementById("student-widget-hours-sub");

    if (pointsVal) pointsVal.innerText = profile.points || 0;
    if (levelVal) levelVal.innerText = profile.level || getLevelName(profile.points || 0);
    if (badgesVal) badgesVal.innerText = profile.badges?.length || 0;
    if (hoursSub) hoursSub.innerText = `Pontos acumulados: ${profile.points || 0}`;

    const coursesSnap = await getDocs(collection(db, "courses"));
    const enrollmentsSnap = await getDocs(query(collection(db, "enrollments"), where("studentId", "==", uid)));
    const progressSnap = await getDocs(query(collection(db, "progress"), where("studentId", "==", uid)));
    const certificatesSnap = await getDocs(query(collection(db, "certificates"), where("studentId", "==", uid)));

    const allCourses = [];
    coursesSnap.forEach(d => allCourses.push({ id: d.id, ...d.data() }));
    window.allCoursesData = allCourses;

    const enrollmentsMap = {};
    enrollmentsSnap.forEach(d => {
      const data = d.data();
      enrollmentsMap[data.courseId] = data;
    });

    const progressMap = {};
    progressSnap.forEach(d => {
      const data = d.data();
      if (!progressMap[data.courseId]) {
        progressMap[data.courseId] = [];
      }
      progressMap[data.courseId].push(data.lessonId);
    });

    const certificatesMap = {};
    certificatesSnap.forEach(d => {
      const data = d.data();
      certificatesMap[data.courseId] = data;
    });

    const modulesSnap = await getDocs(collection(db, "modules"));
    const lessonsSnap = await getDocs(collection(db, "lessons"));

    const moduleToCourse = {};
    modulesSnap.forEach(d => {
      const m = d.data();
      moduleToCourse[d.id] = m.courseId;
    });

    const lessonsByCourse = {};
    lessonsSnap.forEach(d => {
      const l = d.data();
      const courseId = moduleToCourse[l.moduleId] || l.courseId || "";
      if (courseId) {
        if (!lessonsByCourse[courseId]) {
          lessonsByCourse[courseId] = [];
        }
        lessonsByCourse[courseId].push(l);
      }
    });

    let totalProgress = 0;
    let enrolledCoursesCount = 0;

    for (const courseId in enrollmentsMap) {
      const enrollment = enrollmentsMap[courseId];
      const lessons = lessonsByCourse[courseId] || [];
      const totalLessons = lessons.length;
      const completedCount = (progressMap[courseId] || []).length;
      const progressPercent = totalLessons > 0 ? Math.round((completedCount / totalLessons) * 100) : 0;

      if (enrollment.progress !== progressPercent) {
        const enrollmentRef = doc(db, "enrollments", `${uid}_${courseId}`);
        await updateDoc(enrollmentRef, {
          progress: progressPercent,
          status: progressPercent === 100 ? "completed" : "active",
          completedAt: progressPercent === 100 ? new Date().toISOString() : null
        });
        enrollment.progress = progressPercent;
      }

      totalProgress += progressPercent;
      enrolledCoursesCount++;
    }

    const avgProgress = enrolledCoursesCount > 0 ? Math.round(totalProgress / enrolledCoursesCount) : 0;

    let totalDurationSeconds = 0;
    progressSnap.forEach(d => {
      const p = d.data();
      const lessonsList = lessonsByCourse[p.courseId] || [];
      const lessonObj = lessonsList.find(l => l.id === p.lessonId);
      const duration = lessonObj ? (lessonObj.duration || 1800) : 1800;
      totalDurationSeconds += duration;
    });
    const totalHoursStudied = (totalDurationSeconds / 3600).toFixed(1);

    const widgetActive = document.getElementById("student-widget-active-courses");
    const widgetFill = document.getElementById("student-widget-progress-fill");
    const widgetText = document.getElementById("student-widget-progress-text");
    const widgetCert = document.getElementById("student-widget-certificates");
    const widgetCertSub = document.getElementById("student-widget-certificates-sub");

    if (widgetActive) widgetActive.innerText = `${enrolledCoursesCount} Curso(s)`;
    if (widgetFill) {
      widgetFill.setAttribute("data-target", `${avgProgress}%`);
      widgetFill.style.width = `${avgProgress}%`;
    }
    if (widgetText) widgetText.innerText = `Média de progresso: ${avgProgress}%`;
    if (widgetCert) widgetCert.innerText = `${certificatesSnap.size} Certificado(s)`;
    if (widgetCertSub) {
      widgetCertSub.innerText = certificatesSnap.size > 0 ? `${certificatesSnap.size} emitido(s) no total` : "Nenhum certificado emitido";
    }
    if (hoursVal) hoursVal.innerText = `${totalHoursStudied}h estudadas`;

    const myCourses = [];
    const availableCourses = [];

    allCourses.forEach(c => {
      if (enrollmentsMap[c.id]) {
        myCourses.push(c);
      } else {
        availableCourses.push(c);
      }
    });

    renderActiveCoursesProgress(myCourses, lessonsByCourse, progressMap);
    renderMyCoursesGrid(myCourses, enrollmentsMap, lessonsByCourse, progressMap, uid);
    renderAvailableCoursesGrid(availableCourses, uid);
    renderCertificatesGrid(uid, allCourses, enrollmentsMap, lessonsByCourse, progressMap, certificatesMap);

    const historySnap = await getDocs(query(collection(db, "activity_log"), where("studentId", "==", uid)));
    const historyList = [];
    historySnap.forEach(d => historyList.push(d.data()));
    historyList.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
    renderHistoryList(historyList);

    hideDashboardSkeletons();

  } catch (err) {
    console.error("Erro ao carregar dados do aluno:", err);
    hideDashboardSkeletons();
  }
}

function showDashboardSkeletons() {
  const cards = document.querySelectorAll("#tab-dashboard-content .widget-card, #tab-dashboard-content .card-container-box, #tab-dashboard-content .cert-promo-card");
  cards.forEach(card => card.classList.add("skeleton-active"));
}

function hideDashboardSkeletons() {
  const cards = document.querySelectorAll("#tab-dashboard-content .widget-card, #tab-dashboard-content .card-container-box, #tab-dashboard-content .cert-promo-card");
  cards.forEach(card => card.classList.remove("skeleton-active"));
}

function renderActiveCoursesProgress(myCourses, lessonsByCourse, progressMap) {
  const container = document.getElementById("student-active-courses-list");
  if (!container) return;

  const activeEnrolled = myCourses.filter(c => {
    const lessons = lessonsByCourse[c.id] || [];
    const completed = (progressMap[c.id] || []).length;
    return lessons.length > 0 && completed < lessons.length;
  });

  if (activeEnrolled.length === 0) {
    container.innerHTML = `<p style="font-size: 0.9rem; color: var(--text-secondary); text-align: center; margin: var(--space-md) 0;">Você não possui cursos em andamento.</p>`;
    return;
  }

  container.innerHTML = "";
  activeEnrolled.forEach(c => {
    const lessons = lessonsByCourse[c.id] || [];
    const completed = (progressMap[c.id] || []).length;
    const progressPercent = Math.round((completed / lessons.length) * 100);

    const div = document.createElement("div");
    div.className = "active-course-row";
    div.style.cssText = "padding: var(--space-md) 0; border-bottom: 1px solid rgba(11,27,94,0.06); display: flex; justify-content: space-between; align-items: center; gap: var(--space-md);";

    div.innerHTML = `
      <div style="flex: 1;">
        <h4 style="margin: 0 0 6px 0; color: var(--blue-deep); font-weight: 600; font-size: 0.95rem;">${c.title}</h4>
        <div style="display: flex; align-items: center; gap: 10px;">
          <div class="progress-bar" style="height: 6px; flex: 1; background: #E8ECF4; border-radius: 3px; overflow: hidden;">
            <div class="progress-fill" style="width: ${progressPercent}%; height: 100%; background: var(--teal); border-radius: 3px;"></div>
          </div>
          <span style="font-size: 0.8rem; font-weight: 700; color: var(--text-secondary); min-width: 35px; text-align: right;">${progressPercent}%</span>
        </div>
      </div>
      <button class="btn btn-filled btn-access-course-dash ripple-trigger" data-course-id="${c.id}" style="padding: 6px 12px; font-size: 0.8rem; border-radius: var(--radius-sm);">
        Acessar
      </button>
    `;

    div.querySelector(".btn-access-course-dash").addEventListener("click", () => {
      window.location.href = `./course.html?courseId=${c.id}`;
    });

    container.appendChild(div);
  });
}

function renderMyCoursesGrid(courses, enrollmentsMap, lessonsByCourse, progressMap, uid) {
  const grid = document.getElementById("student-courses-grid");
  if (!grid) return;

  if (courses.length === 0) {
    grid.innerHTML = `
      <div style="grid-column: 1 / -1; text-align: center; color: var(--text-secondary); padding: var(--space-xl);">
        <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.5" style="margin-bottom: var(--space-md); opacity: 0.5;"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg>
        <p style="margin: 0; font-size: 0.95rem;">Você não está matriculado em nenhum curso ainda.</p>
        <p style="margin: 6px 0 0 0; font-size: 0.85rem;">Navegue pela aba <strong>Cursos Disponíveis</strong> para se matricular.</p>
      </div>
    `;
    return;
  }

  grid.innerHTML = "";
  courses.forEach(c => {
    const lessons = lessonsByCourse[c.id] || [];
    const completed = (progressMap[c.id] || []).length;
    const progressPercent = lessons.length > 0 ? Math.round((completed / lessons.length) * 100) : 0;
    const isCompleted = progressPercent === 100;

    const article = document.createElement("article");
    article.className = "course-card";
    article.setAttribute("tabindex", "0");
    article.setAttribute("aria-label", `Curso: ${c.title}`);

    const isFavorited = getFavorites().includes(c.id);
    article.innerHTML = `
      <div class="course-thumbnail" style="background-image: url('${c.coverUrl || "./Tecnologia para Serventias.jpg"}'); background-size: cover; background-position: center; height: 160px; position: relative;">
        <div class="course-badge-level" style="position: absolute; top: 12px; left: 12px; background: rgba(11,27,94,0.85); color: #fff; padding: 4px 8px; font-size: 0.72rem; border-radius: var(--radius-sm); font-weight: 700;">
          ${c.level === "intermediate" ? "Intermediário" : c.level === "advanced" ? "Avançado" : "Geral"}
        </div>
        <button class="btn-favorite ripple-trigger ${isFavorited ? 'favorited' : ''}" data-course-id="${c.id}" data-course-title="${c.title}" style="position: absolute; top: 12px; right: 12px; background: rgba(255,255,255,0.9); border: none; border-radius: 50%; width: 36px; height: 36px; display: flex; align-items: center; justify-content: center; cursor: pointer; box-shadow: var(--shadow-sm); transition: all 0.2s ease;">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="${isFavorited ? '#FFD700' : 'none'}" stroke="${isFavorited ? '#FFD700' : '#0B1B5E'}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
        </button>
      </div>
      <div class="course-info" style="padding: var(--space-md); display: flex; flex-direction: column; gap: var(--space-sm);">
        <div style="display: flex; justify-content: space-between; align-items: center; font-size: 0.8rem; color: var(--text-secondary);">
          <span>Carga Horária: ${c.workload || 40}h</span>
          <span style="font-weight: 600; color: ${isCompleted ? "var(--success)" : "var(--text-secondary)"};">
            ${isCompleted ? "Concluído" : `${progressPercent}% concluído`}
          </span>
        </div>
        <h3 class="course-title" style="font-family: var(--font-display); font-size: 1.05rem; font-weight: 700; color: var(--blue-deep); margin: 0; line-height: 1.3;">${c.title}</h3>
        <p style="font-size: 0.85rem; color: var(--text-secondary); margin: 0; line-height: 1.4; height: 55px; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical;">
          ${c.description || ""}
        </p>
        <div class="progress-bar" style="height: 6px; background: #E8ECF4; border-radius: 3px; overflow: hidden; margin-top: 4px;">
          <div class="progress-fill" style="width: ${progressPercent}%; height: 100%; background: ${isCompleted ? "var(--success)" : "var(--teal)"}; border-radius: 3px;"></div>
        </div>
        <button class="btn btn-filled btn-access-course ripple-trigger" data-course-id="${c.id}" style="width: 100%; margin-top: var(--space-sm);">
          Acessar Curso
        </button>
      </div>
    `;

    article.querySelector(".btn-access-course").addEventListener("click", () => {
      window.location.href = `./course.html?courseId=${c.id}`;
    });

    const favBtn = article.querySelector(".btn-favorite");
    favBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      toggleFavorite(c.id, c.title);
      favBtn.classList.toggle("favorited");
      const svg = favBtn.querySelector("svg");
      if (favBtn.classList.contains("favorited")) {
        svg.setAttribute("fill", "#FFD700");
        svg.setAttribute("stroke", "#FFD700");
      } else {
        svg.setAttribute("fill", "none");
        svg.setAttribute("stroke", "#0B1B5E");
      }
    });

    grid.appendChild(article);
  });
}

function getFavorites() {
  try {
    return JSON.parse(localStorage.getItem("courseFavorites") || "[]");
  } catch {
    return [];
  }
}

function saveFavorites(favorites) {
  localStorage.setItem("courseFavorites", JSON.stringify(favorites));
}

function toggleFavorite(courseId, courseTitle) {
  const favorites = getFavorites();
  const index = favorites.indexOf(courseId);
  if (index > -1) {
    favorites.splice(index, 1);
  } else {
    favorites.push(courseId);
  }
  saveFavorites(favorites);
  renderFavoritesGrid();
}

function renderFavoritesGrid() {
  const favoritesTab = document.getElementById("tab-favorites-content");
  if (!favoritesTab) return;
  
  const section = favoritesTab.querySelector("section");
  if (!section) return;
  
  const favoriteIds = getFavorites();
  
  if (favoriteIds.length === 0) {
    section.innerHTML = `
      <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="margin-bottom: var(--space-md); opacity: 0.5;"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
      <p style="font-size: 0.95rem; margin: 0;">Você ainda não favoritou nenhum curso.</p>
      <p style="font-size: 0.85rem; margin: 6px 0 0 0; color: var(--text-secondary);">Clique na estrela em um curso para adicioná-lo aos favoritos.</p>
    `;
    return;
  }
  
  section.innerHTML = `<div id="favorites-grid" class="courses-grid" style="display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: var(--space-md);"></div>`;
  
  const grid = document.getElementById("favorites-grid");
  
  const allCourses = window.allCoursesData || [];
  const favoriteCourses = allCourses.filter(c => favoriteIds.includes(c.id));
  
  if (favoriteCourses.length === 0) {
    section.innerHTML = `
      <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="margin-bottom: var(--space-md); opacity: 0.5;"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
      <p style="font-size: 0.95rem; margin: 0;">Nenhum curso favorito encontrado.</p>
    `;
    return;
  }
  
  favoriteCourses.forEach(c => {
    const article = document.createElement("article");
    article.className = "course-card";
    article.innerHTML = `
      <div class="course-thumbnail" style="background-image: url('${c.coverUrl || "./Tecnologia para Serventias.jpg"}'); background-size: cover; background-position: center; height: 120px; position: relative;">
        <button class="btn-favorite favorited ripple-trigger" data-course-id="${c.id}" data-course-title="${c.title}" style="position: absolute; top: 10px; right: 10px; background: rgba(255,255,255,0.95); border: none; border-radius: 50%; width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; cursor: pointer; box-shadow: var(--shadow-sm);">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="#FFD700" stroke="#FFD700" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
        </button>
      </div>
      <div class="course-info" style="padding: var(--space-md);">
        <h3 style="font-family: var(--font-display); font-size: 0.95rem; font-weight: 700; color: var(--blue-deep); margin: 0 0 6px 0;">${c.title}</h3>
        <p style="font-size: 0.8rem; color: var(--text-secondary); margin: 0 0 10px 0;">Carga Horária: ${c.workload || 40}h</p>
        <button class="btn btn-filled btn-access-course ripple-trigger" data-course-id="${c.id}" style="width: 100%; font-size: 0.85rem; padding: 8px;">
          Acessar Curso
        </button>
      </div>
    `;
    
    article.querySelector(".btn-access-course").addEventListener("click", () => {
      window.location.href = `./course.html?courseId=${c.id}`;
    });
    
    article.querySelector(".btn-favorite").addEventListener("click", (e) => {
      e.stopPropagation();
      toggleFavorite(c.id, c.title);
    });
    
    grid.appendChild(article);
  });
}

function renderAvailableCoursesGrid(availableCourses, uid) {
  const grid = document.getElementById("student-available-courses-grid");
  if (!grid) return;

  if (availableCourses.length === 0) {
    grid.innerHTML = `
      <div style="grid-column: 1 / -1; text-align: center; color: var(--text-secondary); padding: var(--space-xl);">
        <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.5" style="margin-bottom: var(--space-md); opacity: 0.5;"><circle cx="12" cy="12" r="10"></circle><line x1="22" y1="22" x2="16.65" y2="16.65"></line></svg>
        <p style="margin: 0; font-size: 0.95rem;">Não há novos cursos disponíveis para matrícula no momento.</p>
      </div>
    `;
    return;
  }

  grid.innerHTML = "";
  availableCourses.forEach(c => {
    const article = document.createElement("article");
    article.className = "course-card";
    article.setAttribute("tabindex", "0");
    article.setAttribute("aria-label", `Curso Disponível: ${c.title}`);

    article.innerHTML = `
      <div class="course-thumbnail" style="background-image: url('${c.coverUrl || "./Tecnologia para Serventias.jpg"}'); background-size: cover; background-position: center; height: 160px; position: relative;">
        <div class="course-badge-level" style="position: absolute; top: 12px; left: 12px; background: rgba(11,27,94,0.85); color: #fff; padding: 4px 8px; font-size: 0.72rem; border-radius: var(--radius-sm); font-weight: 700;">
          ${c.level === "intermediate" ? "Intermediário" : c.level === "advanced" ? "Avançado" : "Geral"}
        </div>
      </div>
      <div class="course-info" style="padding: var(--space-md); display: flex; flex-direction: column; gap: var(--space-sm);">
        <div style="font-size: 0.8rem; color: var(--text-secondary);">
          <span>Carga Horária: ${c.workload || 40}h</span>
        </div>
        <h3 class="course-title" style="font-family: var(--font-display); font-size: 1.05rem; font-weight: 700; color: var(--blue-deep); margin: 0; line-height: 1.3;">${c.title}</h3>
        <p style="font-size: 0.85rem; color: var(--text-secondary); margin: 0; line-height: 1.4; height: 55px; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical;">
          ${c.description || ""}
        </p>
        <button class="btn btn-filled btn-enroll ripple-trigger" data-course-id="${c.id}" style="width: 100%; margin-top: var(--space-sm); background: var(--teal); border-color: var(--teal);">
          Matricular-se
        </button>
      </div>
    `;

    article.querySelector(".btn-enroll").addEventListener("click", async (e) => {
      e.currentTarget.disabled = true;
      e.currentTarget.innerText = "Matriculando...";
      await enrollStudentInCourse(c.id, c.title, uid);
    });

    grid.appendChild(article);
  });
}

async function enrollStudentInCourse(courseId, courseTitle, uid) {
  try {
    const enrollmentRef = doc(db, "enrollments", `${uid}_${courseId}`);
    await setDoc(enrollmentRef, {
      studentId: uid,
      courseId: courseId,
      enrolledAt: new Date().toISOString(),
      progress: 0,
      status: "active"
    });

    await logActivity(uid, "enrollment", `Matriculou-se no curso: ${courseTitle}`);
    window.showToast(`Parabéns! Você se matriculou no curso "${courseTitle}" com sucesso.`, "success");
    await refreshStudentDashboard(uid);
  } catch (err) {
    console.error("Erro ao realizar matrícula:", err);
    window.showToast("Falha ao se matricular. Verifique sua conexão.", "error");
  }
}

function renderCertificatesGrid(uid, courses, enrollmentsMap, lessonsByCourse, progressMap, certificatesMap) {
  const grid = document.getElementById("student-certificates-grid");
  const promoCard = document.getElementById("student-cert-promo-card");
  const profileName = window.currentStudentProfile ? window.currentStudentProfile.name : "";

  if (!grid) return;

  const completedCourses = courses.filter(c => {
    const enrollment = enrollmentsMap[c.id];
    if (!enrollment) return false;
    const lessons = lessonsByCourse[c.id] || [];
    const completed = (progressMap[c.id] || []).length;
    return lessons.length > 0 && completed === lessons.length;
  });

  if (promoCard) {
    if (completedCourses.length > 0) {
      const latestCompleted = completedCourses[0];
      const cert = certificatesMap[latestCompleted.id];

      const promoTitle = promoCard.querySelector(".cert-promo-title");
      const promoDesc = promoCard.querySelector(".cert-promo-desc");
      const promoViewBtn = promoCard.querySelector(".btn-view-cert-promo");
      const promoDownloadBtn = promoCard.querySelector(".btn-download-cert-direct");

      if (promoTitle) promoTitle.innerText = cert ? "Certificado Disponível" : "Parabéns! Curso Concluído";
      if (promoDesc) {
        promoDesc.innerHTML = cert
          ? `Parabéns! Você concluiu 100% do curso <strong>${latestCompleted.title}</strong> e seu certificado digital está assinado e pronto.`
          : `Você concluiu 100% do curso <strong>${latestCompleted.title}</strong>. Clique abaixo para gerar seu certificado digital oficial.`;
      }

      if (promoViewBtn && promoDownloadBtn) {
        if (cert) {
          promoViewBtn.innerText = "Visualizar Certificado";
          setCertButtonData(promoViewBtn, latestCompleted, cert, profileName);
          promoDownloadBtn.style.display = "inline-flex";
          setCertButtonData(promoDownloadBtn, latestCompleted, cert, profileName);
        } else {
          promoViewBtn.innerText = "Gerar Certificado";
          promoViewBtn.onclick = async () => {
            promoViewBtn.disabled = true;
            promoViewBtn.innerText = "Gerando...";
            await generateCertificate(uid, latestCompleted);
          };
          promoDownloadBtn.style.display = "none";
        }
      }
      promoCard.style.display = "block";
    } else {
      promoCard.style.display = "none";
    }
  }

  if (completedCourses.length === 0) {
    grid.innerHTML = `
      <div style="grid-column: 1 / -1; text-align: center; color: var(--text-secondary); padding: var(--space-xl);">
        <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.5" style="margin-bottom: var(--space-md); opacity: 0.5;"><circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline></svg>
        <p style="margin: 0; font-size: 0.95rem;">Nenhum certificado disponível.</p>
        <p style="margin: 6px 0 0 0; font-size: 0.85rem;">Conclua 100% das aulas de um curso para liberar sua emissão.</p>
      </div>
    `;
    return;
  }

  grid.innerHTML = "";
  completedCourses.forEach(c => {
    const cert = certificatesMap[c.id];
    const card = document.createElement("article");
    card.className = "course-card";
    card.style.border = "1px solid rgba(11,27,94,0.1)";

    if (cert) {
      card.innerHTML = `
        <div class="course-thumbnail" style="background-image: url('${c.coverUrl || "./Tecnologia para Serventias.jpg"}'); background-size: cover; background-position: center; height: 140px; position: relative;">
          <div style="position: absolute; top: 12px; left: 12px; background: var(--success); color: #fff; padding: 4px 8px; font-size: 0.7rem; border-radius: var(--radius-sm); font-weight: 700;">
            Certificado Disponível
          </div>
        </div>
        <div class="course-info" style="padding: var(--space-md); display: flex; flex-direction: column; gap: var(--space-sm);">
          <h3 class="course-title" style="font-family: var(--font-display); font-size: 1.05rem; font-weight: 700; color: var(--blue-deep); margin: 0; line-height: 1.3;">${c.title}</h3>
          <p style="font-size: 0.82rem; color: var(--text-secondary); margin: 0;">Emitido em: ${cert.issueDate}</p>
          <div style="display: flex; gap: var(--space-xs); margin-top: var(--space-xs);">
            <button class="btn btn-filled btn-view-cert ripple-trigger" style="width: 100%; font-size: 0.8rem; padding: 8px 12px;">Visualizar</button>
          </div>
        </div>
      `;

      const viewBtn = card.querySelector(".btn-view-cert");
      setCertButtonData(viewBtn, c, cert, profileName);
    } else {
      card.innerHTML = `
        <div class="course-thumbnail" style="background-image: url('${c.coverUrl || "./Tecnologia para Serventias.jpg"}'); background-size: cover; background-position: center; height: 140px; position: relative;">
          <div style="position: absolute; top: 12px; left: 12px; background: var(--teal); color: #fff; padding: 4px 8px; font-size: 0.7rem; border-radius: var(--radius-sm); font-weight: 700;">
            Aguardando Emissão
          </div>
        </div>
        <div class="course-info" style="padding: var(--space-md); display: flex; flex-direction: column; gap: var(--space-sm);">
          <h3 class="course-title" style="font-family: var(--font-display); font-size: 1.05rem; font-weight: 700; color: var(--blue-deep); margin: 0; line-height: 1.3;">${c.title}</h3>
          <p style="font-size: 0.82rem; color: var(--text-secondary); margin: 0;">Concluído com 100% de aproveitamento!</p>
          <button class="btn btn-filled btn-generate-cert ripple-trigger" style="width: 100%; margin-top: var(--space-xs); background: var(--teal); border-color: var(--teal);">
            Gerar Certificado
          </button>
        </div>
      `;

      card.querySelector(".btn-generate-cert").addEventListener("click", async (e) => {
        e.currentTarget.disabled = true;
        e.currentTarget.innerText = "Gerando...";
        await generateCertificate(uid, c);
      });
    }

    grid.appendChild(card);
  });
}

function setCertButtonData(btn, course, cert, studentName) {
  if (!btn) return;
  btn.setAttribute("data-course-id", course.id);
  btn.setAttribute("data-course-title", course.title);
  btn.setAttribute("data-workload", course.workload || 40);
  btn.setAttribute("data-teacher-name", cert.teacherName || "Dr. Anselmo Arruda");
  btn.setAttribute("data-teacher-signature", cert.teacherSignature || "Dr. Anselmo Arruda");
  btn.setAttribute("data-start-date", cert.startDate || "");
  btn.setAttribute("data-end-date", cert.endDate || cert.issueDate);
  btn.setAttribute("data-student-name", studentName);
  btn.setAttribute("data-cert-id", cert.certificateId);
  btn.setAttribute("data-issue-date", cert.issueDate);
}

async function generateCertificate(uid, course) {
  try {
    const randomIdSuffix = Math.floor(10000 + Math.random() * 90000);
    const certificateId = `AE-2026-${randomIdSuffix}`;
    const hash = generateSHA256Mock(certificateId + course.id);
    const todayStr = formatDateLong(new Date().toISOString());

    let startDate = "";
    try {
      const enrollmentDoc = await getDoc(doc(db, "enrollments", `${uid}_${course.id}`));
      if (enrollmentDoc.exists() && enrollmentDoc.data().enrolledAt) {
        startDate = formatDateLong(enrollmentDoc.data().enrolledAt);
      }
    } catch (e) {}

    const certRef = doc(db, "certificates", `${uid}_${course.id}`);
    const certData = {
      studentId: uid,
      courseId: course.id,
      courseTitle: course.title,
      studentName: window.currentStudentProfile ? window.currentStudentProfile.name : "",
      issueDate: todayStr,
      certificateId: certificateId,
      hash: hash,
      workload: course.workload || 40,
      teacherName: "Dr. Anselmo Arruda",
      teacherSignature: "Dr. Anselmo Arruda",
      startDate: startDate,
      endDate: todayStr
    };

    await setDoc(certRef, certData);
    await logActivity(uid, "certificate_generate", `Emitiu certificado digital para o curso: ${course.title}`);

    window.showToast(`Excelente! Seu certificado digital para "${course.title}" foi emitido e está pronto.`, "success");
    await refreshStudentDashboard(uid);
  } catch (err) {
    console.error("Erro ao gerar certificado:", err);
    window.showToast("Falha ao gerar certificado.", "error");
  }
}

function getLevelName(points) {
  const pts = points || 0;
  if (pts >= 500) return "Master Extrajudicial";
  if (pts >= 300) return "Expert";
  if (pts >= 150) return "Avançado";
  if (pts >= 50) return "Intermediário";
  return "Iniciante";
}

function formatDateLong(isoString) {
  if (!isoString) return "";
  const date = new Date(isoString);
  const months = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
  return `${date.getDate()} de ${months[date.getMonth()]} de ${date.getFullYear()}`;
}

async function logActivity(uid, type, description) {
  try {
    const logRef = collection(db, "activity_log");
    await addDoc(logRef, {
      studentId: uid,
      type: type,
      description: description,
      timestamp: new Date().toISOString()
    });
  } catch (err) {
    console.error("Erro ao registrar atividade:", err);
  }
}

function renderHistoryList(history) {
  const list = document.getElementById("student-history-list");
  if (!list) return;

  if (history.length === 0) {
    list.innerHTML = `<li style="text-align: center; color: var(--text-secondary); padding: var(--space-md);">Nenhuma atividade registrada ainda.</li>`;
    return;
  }

  list.innerHTML = "";
  history.forEach(h => {
    const li = document.createElement("li");
    li.style.cssText = "padding: var(--space-md); border-bottom: 1px solid rgba(11,27,94,0.06); display: flex; align-items: center; justify-content: space-between; gap: var(--space-md);";

    const dateStr = new Date(h.timestamp).toLocaleString("pt-BR", {
      day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit"
    });

    li.innerHTML = `
      <div style="display: flex; align-items: center; gap: var(--space-sm);">
        <div style="background: rgba(42,171,184,0.1); color: var(--teal); width: 36px; height: 36px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 1.1rem;">
          ${getActivityIcon(h.type)}
        </div>
        <span style="color: var(--text-primary); font-size: 0.9rem; font-weight: 500;">${h.description}</span>
      </div>
      <span style="font-size: 0.78rem; color: var(--text-secondary); white-space: nowrap;">${dateStr}</span>
    `;

    list.appendChild(li);
  });
}

function getActivityIcon(type) {
  switch (type) {
    case "login": return "🔑";
    case "streak": return "🔥";
    case "enrollment": return "📚";
    case "lesson_complete": return "✅";
    case "certificate_generate": return "🎓";
    default: return "📝";
  }
}

function generateSHA256Mock(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  let hexString = Math.abs(hash).toString(16).repeat(8);
  if (hexString.length > 64) {
    hexString = hexString.substring(0, 64);
  } else {
    hexString = hexString.padEnd(64, "a");
  }
  return hexString;
}